<div *ngIf=" !isHandset else mobileTemplate" style="min-height: 65.4vh;">
  <div class="container">
    <h2>{{ microfilmMode ? 'Search NARA Records' : 'Search Civil War Archives'}}</h2>
    <p [class]="messageClass">
      {{ message }}
    </p>
    <app-source-call-no-filter *ngIf="dataLoaded" #sourceCallNoCmp (userSelectionReady)="readSourceCallEmitted($event)"
      (changeSourceSelection)="changedSourceSelection($event)" (setCallNumberSelection)="changeCallNumberSelection($event)" [callNumberData]="callNumberData"
      [sourceData]="sourceData" [activeFilter]="chosenSourceCallNumber"></app-source-call-no-filter>
    <br>
    <!-- <button class="btn btn-secondary" type="button" (click)="resetSearchParams()">
      Reset
    </button>
    <button class="btn btn-primary ms-1" [disabled]="!searchFilters.filters.length" type="submit" (click)="executeSearch()">
      <i class="fal fa-search"></i>
      Search&hellip;
    </button> -->
    <app-slant-button btnColor="gray" (click)="resetSearchParams()" btnIconClass="fa-times">Reset</app-slant-button>
    <app-slant-button class="ms-1" [chevronMode]="true" [disabled]="!searchFilters.filters.length" [submitMode]="true" (click)="executeSearch()" btnIconClass="fa-search">Search &hellip;</app-slant-button>
    <br><br>
  </div>
  <div style="width: 80%; margin: auto;" [hidden]="chosenSourceCallNumber === null || !chosenSourceCallNumber.lU_SourceUID">
    <lib-new-table-editor #microfilmTable [modelName]="'Microfilm'"
      (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
      (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
      (dblClickEmitter)="viewCallNoRecords($event)"
      [userViewOptions]="microfilmViewOptions"
      [loadAllClientside]="false"
      [tooltipDelay]="100"
      [dataSvc]="callNoSvc"
      [columns]="microfilmColumns"
      [tableEditable]="false">
      <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="microfilmColumns" let-editRow="editRow" let-compactMode="compactMode">
        <span style="display: contents;" lib-table-row
          [rowData]="rowData"
          [columnDefinitions]="microfilmColumns"
          [editRow]="editRow"
          [allowEdit]="false"
          [compactMode]="compactMode"></span>
      </ng-template>
    </lib-new-table-editor>
  </div>
</div>
<app-site-footer style="bottom: 0; width: 100%; z-index: 1;"></app-site-footer>


<ng-template #mobileTemplate>

  <div style="min-height: 65vh;">
    <div class="container">
      <h2>{{ microfilmMode ? 'Search NARA Records' : 'Search Civil War Archives'}}</h2>
      <p [class]="messageClass">
        {{ message }}
      </p>
      <app-source-call-no-filter #sourceCallNoCmp (userSelectionReady)="readSourceCallEmitted($event)"
        (changeSourceSelection)="changedSourceSelection($event)" (setCallNumberSelection)="changeCallNumberSelection($event)" [callNumberData]="callNumberData"
        [sourceData]="sourceData" [activeFilter]="chosenSourceCallNumber"></app-source-call-no-filter>
      <br>
      <!-- <button class="btn btn-secondary" type="button" (click)="resetSearchParams()">
        Reset
      </button>
      <button class="btn btn-primary ms-1" [disabled]="!searchFilters.filters.length" type="submit" (click)="executeSearch()">
        <i class="fal fa-search"></i>
        Search&hellip;
      </button> -->
      <app-slant-button btnColor="gray" (click)="resetSearchParams()" btnIconClass="fa-times">Reset</app-slant-button>
      <app-slant-button class="ms-1" [chevronMode]="true" [disabled]="!searchFilters.filters.length" [submitMode]="true" (click)="executeSearch()" btnIconClass="fa-search">Search &hellip;</app-slant-button>
      <br><br>
    </div>
    <div style="width: 98vw; margin: auto; max-width: 98vw; overflow-x: scroll;" [hidden]="chosenSourceCallNumber === null || !chosenSourceCallNumber.lU_SourceUID">
      <lib-new-table-editor #microfilmTable [modelName]="'Microfilm'"
        (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
        (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
        (dblClickEmitter)="viewCallNoRecords($event)"
        [userViewOptions]="microfilmViewOptions"
        [loadAllClientside]="false"
        [tooltipDelay]="100"
        [dataSvc]="callNoSvc"
        [columns]="microfilmColumns"
        [tableEditable]="false">
        <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="microfilmColumns" let-editRow="editRow" let-compactMode="compactMode">
          <span style="display: contents;" lib-table-row
            [rowData]="rowData"
            [columnDefinitions]="microfilmColumns"
            [editRow]="editRow"
            [allowEdit]="false"
            [compactMode]="compactMode"></span>
        </ng-template>
      </lib-new-table-editor>
    </div>
  </div>
</ng-template>